import { useQuery } from "@apollo/client/react";
import { GET_TIPO_PROFESIONAL_BY_ID_PLAN_CUIDADO } from "../../../../../data/graphQL/queries/GestionAsistencial/getTipoProfesionalByIdPlanCuidado";
import { GET_FIGURA_PROFESIONAL_BY_ID_PLAN_CUIDADO } from "../../../../../data/graphQL/queries/GestionAsistencial/getFiguraProfesionalByPlanCuidado";
import { GET_FORMA_LIQUIDACION_PROFESIONAL } from "../../../../../data/graphQL/queries/GestionAsistencial/getFormaLiquidacionProfesional";
import { GET_PROFESIONALES } from "../../../../../data/graphQL/queries/GestionAsistencial/getProfesionales";
import { GET_TRAMO_PROFESIONAL } from "../../../../../data/graphQL/queries/GestionAsistencial/getTramoProfesional";
import { GET_FRECUENCIAS_PROFESIONALES } from "../../../../../data/graphQL/queries/GestionAsistencial/getFrecuenciasProfesionales";
import { adaptOptionsFromEntity } from "../../../../../adapters/adaptOptionsFromEntity";
import { adaptTramosProfesionales } from "../../../../../adapters/gestionAsistencial/adaptTramosProfesionales";
import { adaptProfesionales } from "../../../../../adapters/gestionAsistencial/adaptProfesional";
import { adaptFrecuenciasProfesionales } from "../../../../../adapters/gestionAsistencial/adaptFrecuenciasProfesionales";
import adaptClasificacionesMonitoreoArray, { GET_ALL_CLASIFICACIONES_MONITOREO } from "../../../../../data/graphQL/queries/Honorarios/getClasificacionesMonitoreo";

export function useTabProfesionalAddProfessionalFields({
  idPlanCuidado,
  idTipoProfesional,
  idDelegacion,
  idProfesionalOriginal,
  origenEvaluacion,
  idEvaluacion
}) {
  const { data: dataTipoProfesional } = useQuery(
    GET_TIPO_PROFESIONAL_BY_ID_PLAN_CUIDADO,
    {
      skip: !idPlanCuidado,
      variables: {
        idPlanCuidado
      },
      fetchPolicy: 'no-cache'
    }
  );

  const { data: dataFiguraProfesional } = useQuery(
    GET_FIGURA_PROFESIONAL_BY_ID_PLAN_CUIDADO,
    {
      skip: !idPlanCuidado || !idTipoProfesional,
      variables: {
        idPlanCuidado,
        idTipoProfesional: idTipoProfesional,
        idEvaluacion: idEvaluacion
      },
      fetchPolicy: 'no-cache'
    }
  );

  const { data: dataFormaLiquidacionProfesional } = useQuery(
    GET_FORMA_LIQUIDACION_PROFESIONAL,
    {
      skip: !idTipoProfesional,
      variables: {
        idTipoProfesional: idTipoProfesional
      },
      fetchPolicy: 'no-cache'
    }
  );

  const { data: dataProfesionales } = useQuery(GET_PROFESIONALES, {
    skip: !idDelegacion || !idTipoProfesional,
    variables: {
      idDelegacion,
      idTipoProfesional: idTipoProfesional
    },
    fetchPolicy: 'no-cache'
  });

  const { data: dataClasificacionMonitoreo } = useQuery(
    GET_ALL_CLASIFICACIONES_MONITOREO,
    { fetchPolicy: 'no-cache' }
  );

  const { data: dataTramoProfesional } = useQuery(GET_TRAMO_PROFESIONAL, {
    skip: !idDelegacion || !idTipoProfesional,
    variables: {
      idDelegacion,
      idTipoProfesional: idTipoProfesional
    },
    fetchPolicy: 'no-cache'
  });

  const { data: dataFrecuenciaProfesional } = useQuery(
    GET_FRECUENCIAS_PROFESIONALES,
    { fetchPolicy: 'no-cache' }
  );

  const tipoOptions = [
    {
      id: 1,
      displayName: "Seguimiento"
    },
    // {
    //   id: 2,
    //   displayName: "Evaluador"
    // }
  ];


  const tipoProfesionalOptions = adaptOptionsFromEntity(
    dataTipoProfesional,
    "tipoProfesionalByIdPlanCuidado",
    {
      idKey: "idTipoProfesional",
      displayNameKey: "descripcion"
    }
  );

  const figuraProfesionalOptions = adaptOptionsFromEntity(
    dataFiguraProfesional,
    "figuraProfesionalByIdPlanCuidado",
    {
      idKey: "idFiguraProfesional",
      displayNameKey: "descripcion"
    }
  );

  const formaLiquidacionProfesionalOptions = adaptOptionsFromEntity(
    dataFormaLiquidacionProfesional,
    "formaLiquidacionProfesional",
    {
      idKey: "idFormaLiquidacion",
      displayNameKey: "descripcion"
    }
  );

  const profesionalOptions = adaptProfesionales(dataProfesionales);

  const clasificacionMonitoreoOptions = adaptClasificacionesMonitoreoArray(dataClasificacionMonitoreo);

  const tramoProfesionalOptions = adaptTramosProfesionales(dataTramoProfesional);

  const frecuenciaProfesionalOptions = adaptFrecuenciasProfesionales(dataFrecuenciaProfesional);

  const fields = [
    // First row
    {
      displayName: "Tipo",
      name: "idTipo",
      type: "select",
      options: tipoOptions,
      col: 3
    },
    {
      displayName: "Tipo de profesional",
      name: "idTipoProfesional",
      type: "select",
      options: tipoProfesionalOptions,
      disabled: true,
      col: 4
    },
    {
      displayName: "Figura profesional",
      name: "idFiguraProfesional",
      type: "select",
      options: figuraProfesionalOptions,
      disabled: true,
      col: 4
    },
    // Second row
    {
      displayName: "Desde",
      name: "fechaDesde",
      type: "date",
      col: 3
    },
    {
      displayName: "Hasta",
      name: "fechaHasta",
      type: "date",
      col: 3
    },
    {
      displayName: "Forma liquidación",
      name: "idFormaLiquidacion",
      type: "select",
      options: formaLiquidacionProfesionalOptions,
      disabled: true,
      col: 4
    },
    // third row
    {
      displayName: "Profesional",
      name: "idProfesional",
      type: "autocomplete",
      options: profesionalOptions,
      disabled: true,
      col: 6.5
    },
    {
      displayName: "Clasificación monitoreo",
      name: "idClaseMonitoreo",
      type: "select",
      options: clasificacionMonitoreoOptions,
      disabled: true,
      col: 3.5
    },
    // fourth row
    {
      displayName: "Frecuencia plan",
      name: "idFrecuenciaPlan",
      type: "select",
      options: frecuenciaProfesionalOptions,
      disabled: true,
      col: 3.5
    },
    {
      displayName: "Frecuencia requerida",
      name: "idFrecuenciaRequerida",
      type: "select",
      options: frecuenciaProfesionalOptions,
      disabled: true,
      col: 3.5
    }];


  return { fields, tramoProfesionalOptions, profesionalOptions, dataFrecuenciaProfesional, figuraProfesionalOptions };
}